export default __webpack_public_path__ + "static/zu3-8ee524927714eed9299113c6bf1e136f.png";